import { useEffect } from "react"
import { FormikTouched } from "formik"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { checkDataLayerField } from "../helpers"

type Props = {
  touched?: FormikTouched<{}>
  error?: string
  name: string
  children: JSX.Element
  focus?: boolean
}

export const WrapperDataLayer = ({ touched, error, name, children, focus }: Props) => {
  useEffect(() => {
    if (focus) {
      pushToDataLayer({
        event: "GAFormEvent",
        eventCategory: "fieldFocused",
        eventAction: name,
        eventLabel: globalThis?.location?.href,
        placement: "main",
      })
    }
  }, [focus, name])

  useEffect(() => {
    checkDataLayerField(touched, error, name)
  }, [error, name, touched])
  return children
}
